import React, {
  useState,
  forwardRef,
  useImperativeHandle
} from "react";
import {
  Box,
  Typography,
  TextField,
  Chip,
  IconButton,
  Collapse,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const servicios = ["flux", "enviro", "nanoox", "scapp"];

const EmailsPorServicio = forwardRef(({ emails, setEmails, textfieldStyle }, ref) => {
  const [open, setOpen] = useState(true);
  const [emailInput, setEmailInput] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [error, setError] = useState(null);

  const handleToggleService = (service) => {
    setSelectedServices((prev) =>
      prev.includes(service)
        ? prev.filter((s) => s !== service)
        : [...prev, service]
    );
  };

  const addEmailToState = () => {
    const email = emailInput.trim().toLowerCase();

    if (!EMAIL_REGEX.test(email)) return;
    if (selectedServices.length === 0) return;

    setEmails((prev) => {
      const next = { ...prev };
      selectedServices.forEach((service) => {
        if (!next[service].includes(email)) {
          next[service] = [...next[service], email];
        }
      });
      return next;
    });

    setEmailInput("");
    setSelectedServices([]);
    setError(null);
  };

  // 👇 MÉTODO EXPUESTO AL PADRE
  useImperativeHandle(ref, () => ({
    commitPendingEmail() {
      if (!emailInput) return;
      if (!EMAIL_REGEX.test(emailInput)) return;
      if (selectedServices.length === 0) return;

      addEmailToState();
    }
  }));

  const handleAdd = () => {
    if (!EMAIL_REGEX.test(emailInput)) {
      setError("Email inválido");
      return;
    }
    if (selectedServices.length === 0) {
      setError("Selecciona al menos un servicio");
      return;
    }
    addEmailToState();
  };

  const handleDelete = (email) => {
    setEmails((prev) => {
      const next = {};
      servicios.forEach((s) => {
        next[s] = prev[s].filter((e) => e !== email);
      });
      return next;
    });
  };

  const emailsUnicos = Array.from(
    new Set(servicios.flatMap((s) => emails[s]))
  );

  return (
    <Box
      sx={{
        border: "0.01vw solid rgba(233,78,26,.5)",
        borderRadius: "0.4vw",
        padding: "1vh",
        marginTop: "1vh"
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ cursor: "pointer" }}
        onClick={() => setOpen((p) => !p)}
      >
        <Typography sx={{ fontSize: "1vw", color: "#c3c3c3" }}>
          Correos de notificación
        </Typography>
        <ExpandMoreIcon
          sx={{
            color: "#e94e1a",
            transform: open ? "rotate(180deg)" : "rotate(0)",
            transition: "0.2s",
            fontSize:'1vw'
          }}
        />
      </Box>

      <Collapse in={open}>
        {/* Input */}
        <Box display="flex" marginTop="1vh">
          <TextField
            value={emailInput}
            onChange={(e) => {
              setEmailInput(e.target.value);
              setError(null);
            }}
            placeholder="correo@dominio.com"
            error={!!error}
            helperText={error}
            fullWidth
            sx={textfieldStyle}
            // sx={{
            //   "& input": { color: "#c3c3c3", fontSize: "0.8vw" }
            // }}
          />
          <IconButton onClick={handleAdd}>
            <AddIcon sx={{ color: "#e94e1a", fontSize:'1vw' }} />
          </IconButton>
        </Box>

        {/* Servicios */}
        <Box display="flex" gap={2} marginTop="1vh" flexWrap="wrap">
          {servicios.map((s) => (
            <FormControlLabel
              key={s}
              control={
                <Checkbox
                  checked={selectedServices.includes(s)}
                  onChange={() => handleToggleService(s)}
                  sx={{
                    width: "1.1vw",
                    height: "1.1vw",
                    padding: "0.2vw",
                    color: "#e94e1a",
                    "& .MuiSvgIcon-root": {
                      fontSize: "1.1vw",
                    },
                    "&.Mui-checked": {
                      color: "#e94e1a",
                    },
                  }}
                />
              }
              label={s.toUpperCase()}
              sx={{
                margin: 0,
                gap: "0.35vw",
                color: "#c3c3c3",
                "& .MuiFormControlLabel-label": {
                  fontSize: "0.75vw",
                  lineHeight: 1,
                },
              }}
            />
          ))}
        </Box>

        {/* Chips */}
        <Box display="flex" gap={0.5} flexWrap="wrap" marginTop="1vh">
          {emailsUnicos.map((email) => {
            const serviciosEmail = servicios.filter((s) =>
              emails[s].includes(email)
            );

            return (
              <Chip
                key={email}
                label={`${email} · ${serviciosEmail.join(", ")}`}
                onDelete={() => handleDelete(email)}
                size="small"
                sx={{
                  backgroundColor: "rgba(233,78,26,.15)",
                  color: "#c3c3c3",
                  fontSize: "0.65vw"
                }}
              />
            );
          })}
        </Box>
      </Collapse>
    </Box>
  );
});

export default EmailsPorServicio;
